import { Divider, Text } from "@fluentui/react-components";
import styled from "styled-components";

type Props = {
  title: string;
};

export function FieldsSectionTitle({ title }: Props) {
  return (
    <Container>
      <Text size={400} weight="semibold">
        {title}
      </Text>
      <Divider
        style={{
          margin: "10px 0 20px",
        }}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
`;
